export const joinReferences = {
  PARENT: 1,
  CHILD: 2,
  PIVOT: 3,
}

export const riskRatings = [
  ...([
    'AA', // 1
    'A', // 2
    'B', // 3
    'C', // 4
    'D', // 5
    'E', // 6
    'F', // 7
    'HR', // 8
  ].map(literal => ({
    // score: index + 1,
    value: literal,
    literal,
  }))),
  {
    // score: 9,
    value: null,
    literal: 'N/A',
  },
]

export const loanStatuses = [
  null,
  'Reserved',
  'Current',
  'Cancelled',
  'Repaid',
  'Released',
  'Overdue',
  'Overdue (30+ days)',
  'Overdue (60+ days)',
  'Overdue (90+ days)',
]

export const loanTypes = [
  null,
  'Loan consolidation',
  'Real estate',
  'Home improvement',
  'Business',
  'Education',
  'Travel',
  'Vehicle',
  'Health',
  'Other',
  'Invoice financing',
]

export const loanIncomeVerification = [
  'Not verified',
  'By phone',
  'By other document',
  'By bank statement',
]

export const gender = [
  null,
  'Male',
  'Female',
  'Other',
]

export const accountStatus = [
  'Undetermined',
  'Valid',
  'Validating',
  'Insufficient scope',
  'Invalid credentials',
  'Expired credentials',
  'Revoked crendetials',
  'No credentials',
  'Api error',
  'Expired credentials',
  'Platform took too long to verify',
]
